module.exports = __webpack_public_path__ + "img/inner_4_4.7e7f7836.png";